import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import IssuesHeader from "../components/issues-header"
import IssuesLeadSponsoredLegislationSecondTermDoc from "../components/issues-lead-sponsored-legislation-second-term-doc"
import IssueCards from "../components/issue-cards"

const IssuesPage = () => (
  <Layout>
    <Seo title="Issues" />
    <IssuesHeader />
    <IssuesLeadSponsoredLegislationSecondTermDoc />
    <IssueCards />
  </Layout>
)

export default IssuesPage